import React, { useEffect, useContext } from 'react';
import './application-submitted.scss';
import { VodaLendLogoCompare } from 'assets';
import { ProgressBar } from 'components';
import { LendingContext } from 'context';
import { useNavService } from 'hooks';
import { TealiumService } from 'services';
import { applicationDefaults } from 'utils';
import { routes } from 'router';

const POST_WIZARD_STEPS = [
  { group: 'otp', step: 'otp', route: routes.otp },
  { group: 'documents', step: 'documents', route: routes.documents },
  { group: 'application_submitted', step: 'application_submitted', route: routes.applicationSubmitted },
];

export const ApplicationSubmitted = () => {
  const navigate = useNavService();
  const { application } = useContext(LendingContext);

  useEffect(() => {
    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onApplicationSubmittedStart(omfOffer, application?.offers?.hashId);
  }, []);

  return (
    <section className='app-submitted'>
      <ProgressBar
        steps={POST_WIZARD_STEPS}
        currentStep={POST_WIZARD_STEPS[2]}
        onBack={() => navigate.back()}
        hideBack={false}
      />

      <main className='app-submitted__content'>
        <div className='app-submitted__body'>
          <div className='app-submitted__check-wrap' aria-hidden='true'>
            <svg className='app-submitted__checkmark' viewBox='0 0 80 70' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <polyline points='8,38 30,60 72,10' stroke='#c0392b' strokeWidth='7' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
          </div>

          <h2 className='app-submitted__heading'>Application submitted successfully</h2>

          <p className='app-submitted__description'>
            Please expect a call from our trusted partner, Old Mutual Finance. They will contact you
            shortly from 021 980 0655.
          </p>

          <div className='app-submitted__crosssell'>
            <div className='app-submitted__crosssell-logo-row'>
              <span className='app-submitted__crosssell-heart' aria-hidden='true'>&#10084;</span>
              <span className='app-submitted__crosssell-brand'>vodasure</span>
              <span className='app-submitted__crosssell-pipe'>|</span>
              <span className='app-submitted__crosssell-product'>funeral cover</span>
            </div>
            <p className='app-submitted__crosssell-body'>
              Cover up to 8 adults + 10 children{' '}
              <strong>from R56 per month</strong>
            </p>
            <div className='app-submitted__crosssell-footer'>
              <button
                className='app-submitted__crosssell-cta'
                onClick={() => {
                  const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
                  TealiumService.onApplicationBannerClick(omfOffer, application?.offers?.hashId);
                  window.open(applicationDefaults.staticHomeUrl, '_blank');
                }}
              >
                Get a quote
              </button>
              <span className='app-submitted__crosssell-tc'>Terms &amp; Conditions apply</span>
            </div>
          </div>
        </div>

        <footer className='app-submitted__footer'>
          <img
            className='app-submitted__vodalend-logo'
            src={VodaLendLogoCompare}
            alt='VodaLend personal loans'
          />
          <span className='app-submitted__vodalend-label'>personal loans</span>

          <div className='app-submitted__branding'>
            <span className='app-submitted__branding-label'>IN ASSOCIATION WITH</span>
            <div className='app-submitted__branding-logo-row'>
              <span className='app-submitted__branding-logo-text'>
                <span className='app-submitted__branding-old'>OLD</span>
                <span className='app-submitted__branding-mutual'>MUTUAL</span>
              </span>
            </div>
            <span className='app-submitted__branding-sub'>Old Mutual Finance NCRCP35 FSP25494</span>
          </div>

          <button
            className='app-submitted__finish'
            onClick={() => (window.location.href = applicationDefaults.staticHomeUrl)}
          >
            Finish
          </button>
        </footer>
      </main>
    </section>
  );
};
